// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CUSTOM_ELEMENTS_SCHEMA, Component, Input } from '@angular/core';

@Component({
  selector: 'app-linkToXmart',
  templateUrl: './linkToXmart.component.html',
  styleUrls: ['./linkToXmart.component.css'],
  standalone: true,

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LinkToXmartComponent {
  @Input() xmartSummaryLink?: string;
  urlToXmartSummary = '';

  constructor() {
    // Do Nothing
  }

  private appendHttpToUrl(url: string): string {
    let appendedUrl = '';
    if (!/^https?:\/\//.test(url)) {
      appendedUrl += 'https://';
    }
    appendedUrl += url;

    return appendedUrl;
  }

  public onClickOpenLinkToSummary(): void {
    this.urlToXmartSummary = this.appendHttpToUrl(this.xmartSummaryLink!);
    window.open(this.urlToXmartSummary, '_blank');
  }
}
